import { FaCaretRight } from "react-icons/fa";
import styles from "../../styles/shared/service-activation/ActivateServiceByCrypto.module.css";
import React, { useState } from "react";
import { Button, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  activateServiceWithCard,
  activateServiceWithCrypto,
} from "../../redux/pricing-plan/action";
import { calculateOffPrice } from "../../utility/helper";
import ActivationDurationOptions from "./ActivationDurationOptions";
import {
  renderServiceActivationMode,
  servicesCost,
} from "../../utility/service-activation";
import useServiceStatus from "../../hooks/useServiceStatus";
import useUserTier from "../../hooks/useUserTier";

function ActivateServiceByPayment({
  service,
  style,
  paymentType,
  changeContent,
  setStep,
  content,
}) {
  const {
    pricingPlan: {
      activateServiceWithCryptoStatus,
      activateServiceWithCardStatus,
      pricingPlan,
      activateServiceWithCryptoResponse: cryptoResponse,
      activateServiceWithCardResponse: cardResponse,
    },
    main: { userData },
  } = useSelector((state) => state);
  const [selectedDuration, setSelectedDuration] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const { isActive: isAlertActive } = useServiceStatus("alert");

  const handleChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const offPercentage =
    pricingPlan["yearly_discount"] || servicesCost["yearly_discount"];

  const { serviceType: alertService } = useUserTier("alert");

  const additionalCost = isChecked
    ? pricingPlan[alertService] || servicesCost[alertService]
    : 0;

  const cost = (pricingPlan[service] || servicesCost[service]) + additionalCost;

  const showAlertSuggestion = !isAlertActive && !service.includes("alert");

  const dispatch = useDispatch();

  const activateServiceByCrypto = () => {
    if (
      activateServiceWithCryptoStatus === "loading" ||
      activateServiceWithCardStatus === "loading" ||
      !selectedDuration
    )
      return;

    const amount =
      selectedDuration > 1
        ? calculateOffPrice(offPercentage, cost, selectedDuration, "price")
        : cost;

    const redirectUrl = window.location.href;

    if (paymentType === "crypto") {
      dispatch(
        activateServiceWithCrypto(
          userData?.["custom:custom_username"],
          userData?.email,
          renderServiceActivationMode(service, isChecked),
          `${amount}`,
          redirectUrl,
          redirectUrl,
        ),
      );
    }

    if (paymentType === "card") {
      dispatch(
        activateServiceWithCard(
          userData?.["custom:custom_username"],
          userData?.email,
          renderServiceActivationMode(service, isChecked),
          `${amount}`,
          redirectUrl,
          redirectUrl,
        ),
      );
    }

    changeContent("result");
    setStep(3);
  };

  const checkoutWithCrypto = () => {
    window.open(
      cryptoResponse?.checkout_session_url?.data?.invoice_url,
      "_self",
    );
  };

  const checkoutWithCard = () => {
    window.open(cardResponse?.checkout_session_url, "_self");
  };

  const changeDuration = (duration) => {
    setSelectedDuration(duration);
    changeContent("methods");
  };

  return (
    <div className={styles.container} style={style || {}}>
      {showAlertSuggestion && (
        <Checkbox onChange={handleChange}>
          <span style={{ fontFamily: "Poppins-Regular" }}>
            Receive alerts for just an additional $
            {pricingPlan[alertService] || servicesCost[alertService]}
          </span>
        </Checkbox>
      )}
      <p className={styles.question}>
        <FaCaretRight />
        How many months would you like to activate this service for?
      </p>
      <ActivationDurationOptions
        service={service}
        selectedDuration={selectedDuration}
        setSelectedDuration={changeDuration}
        activationType={"payment"}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
        additionalCost={additionalCost}
      />
      <div className={styles.submitBtnContainer}>
        {content === "methods" && (
          <Button
            className={styles.submitBtn}
            disabled={!selectedDuration}
            onClick={activateServiceByCrypto}
          >
            Generate Checkout Link
          </Button>
        )}
        {paymentType === "crypto" && content === "result" && (
          <>
            <Button
              className={styles.submitBtn}
              loading={activateServiceWithCryptoStatus === "loading"}
              disabled={
                cryptoResponse?.checkout_session_url?.status === "error" ||
                activateServiceWithCryptoStatus === "error" ||
                cryptoResponse?.checkout_session_url?.status !== "success" ||
                cryptoResponse?.can_proceed === "False"
              }
              onClick={checkoutWithCrypto}
            >
              {activateServiceWithCryptoStatus === "loading"
                ? "Generating Checkout Link"
                : "Pay with Crypto"}
            </Button>
            {(cryptoResponse?.checkout_session_url?.status === "error" ||
              activateServiceWithCryptoStatus === "error" ||
              cryptoResponse?.checkout_session_url?.status !== "success" ||
              cryptoResponse?.can_proceed === "False") &&
              activateServiceWithCryptoStatus !== "loading" && (
                <span>Something went wrong!</span>
              )}
          </>
        )}
        {paymentType === "card" && content === "result" && (
          <>
            <Button
              className={styles.submitBtn}
              loading={activateServiceWithCardStatus === "loading"}
              disabled={
                cardResponse?.can_proceed !== "True" ||
                activateServiceWithCardStatus === "error"
              }
              onClick={checkoutWithCard}
            >
              {activateServiceWithCardStatus === "loading"
                ? "Generating Checkout Link"
                : "Pay with Card"}
            </Button>
            {(cardResponse?.can_proceed !== "True" ||
              activateServiceWithCardStatus === "error") &&
              activateServiceWithCardStatus !== "loading" && (
                <span>Something went wrong!</span>
              )}
          </>
        )}
        {/*<Button*/}
        {/*  className={styles.submitBtn}*/}
        {/*  loading={*/}
        {/*    activateServiceWithCryptoStatus === "loading" ||*/}
        {/*    activateServiceWithCardStatus === "loading"*/}
        {/*  }*/}
        {/*  disabled={!selectedDuration}*/}
        {/*  onClick={activateServiceByCrypto}*/}
        {/*>*/}
        {/*  Submit*/}
        {/*</Button>*/}
      </div>
    </div>
  );
}

export default ActivateServiceByPayment;
